import React from 'react';
import { Card, Table, Typography, Button } from 'antd';

const { Title, Paragraph, Text } = Typography;

const WLClients = () => {
  const columns = [
    { title: 'Company', dataIndex: 'company', key: 'company' },
    { title: 'Primary Contact', dataIndex: 'contact', key: 'contact' },
    { title: 'Email', dataIndex: 'email', key: 'email' },
    { title: 'Domain', dataIndex: 'domain', key: 'domain' },
    { title: 'Plan', dataIndex: 'plan', key: 'plan', width: 140 },
    { title: 'Status', dataIndex: 'status', key: 'status', width: 120 },
  ];

  const data = [
    {
      key: '1',
      company: 'Acme Analytics Co.',
      contact: 'Jane Doe',
      email: 'jane@acme.com',
      domain: 'analytics.acme.com',
      plan: 'White Label',
      status: 'Active',
    },
    {
      key: '2',
      company: 'Nimbus UX Studio',
      contact: 'Mark Rivers',
      email: 'mark@nimbusux.io',
      domain: 'insights.nimbusux.io',
      plan: 'White Label',
      status: 'Active',
    },
    {
      key: '3',
      company: 'Northwind Retail Group',
      contact: 'Sarah Lee',
      email: 'sarah@northwind-retail.com',
      domain: 'analytics.northwind-retail.com',
      plan: 'Trial',
      status: 'Trial',
    },
  ];

  return (
    <div className="wl-clients">
      <div style={{ maxWidth: 900, margin: '0 auto' }}>
        <Title level={2} style={{ marginBottom: 8 }}>
          Partner Companies
        </Title>
        <Paragraph type="secondary" style={{ marginBottom: 16 }}>
          This is a starter view listing companies that run Asuma as their own analytics product. Replace the
          static table with real data from your backend when ready.
        </Paragraph>

        <Card
          style={{ borderRadius: 14, marginBottom: 16 }}
          extra={
            <Button type="primary" size="small">
              New partner
            </Button>
          }
          title="Companies"
        >
          <Table
            columns={columns}
            dataSource={data}
            rowKey="key"
            pagination={{ pageSize: 5, showSizeChanger: false }}
            size="small"
          />
        </Card>

        <Card style={{ borderRadius: 14 }}>
          <Title level={4} style={{ marginBottom: 8 }}>
            How this fits your White Label plan
          </Title>
          <Paragraph>
            Each company here corresponds to a tenant that has bought your White Label plan. When you wire this page
            to your API, you can surface their limits (websites, events, users) based on the White Label plan
            configuration you already have in your backend.
          </Paragraph>
          <Text type="secondary">
            For now this page is read-only demo data and safe to ship to production.
          </Text>
        </Card>
      </div>
    </div>
  );
};

export default WLClients;
